import type {
  NavGroup,
  NavItem,
  PreferencesMenu,
  SettingsMenu,
} from "@/client/features/navigation/types";
import { IconBinaryTree2, IconMap, IconUser } from "@tabler/icons-react";
import {
  RadarIcon,
  RocketIcon,
  MapIcon,
  UserIcon,
  SquareArrowRightIcon,
} from "lucide-react";

export const mainNavItems: NavItem[] = [
  // {
  //   id: "pdar",
  //   label: "PDAR",
  //   to: "/map/pdar",
  //   icon: RadarIcon,
  // },
  {
    id: "skopa",
    label: "SKOPA",
    to: "/map/skopa",
    icon: RocketIcon,
  },
];

export const secondaryNavItems: NavGroup[] = [
  {
    id: "Map",
    label: "Map",
    items: [
      {
        id: "settings-map-position",
        label: "Map Position",
        to: "/map/skopa",
      },
    ],
  },
];

export const modulesNavItems: SettingsMenu[] = [
  {
    title: "Skopa",
    icon: RocketIcon,
    isActive: true,
    items: [
      // {
      //   title: "View",
      //   url: "/settings/skopa/view",
      // },
      {
        title: "Config",
        url: "/settings/skopa/config",
      },
      {
        title: "Logs",
        url: "/settings/skopa/logs",
      },
      {
        title: "Docs",
        url: "/settings/skopa/docs",
      },
    ],
  },
  // {
  //   title: "PDAR",
  //   icon: RadarIcon,
  //   isActive: true,
  //   items: [
  //     {
  //       title: "Stations",
  //       url: "/settings/pdar/stations",
  //     },
  //     {
  //       title: "AoAs",
  //       url: "/settings/pdar/aoas",
  //     },
  //     {
  //       title: "Docs",
  //       url: "/settings/pdar/docs",
  //     },
  //   ],
  // },
];

export const preferencesNavItems: PreferencesMenu[] = [
  {
    name: "Map",
    url: "/settings/map",
    icon: IconMap,
  },
  {
    name: "Channels",
    url: "/settings/channels",
    icon: IconBinaryTree2,
  },
  {
    name: "Admin",
    url: "/settings/admin",
    icon: IconUser,
  },
];
